
/* injects from baggage-loader */

'use strict';

export default function (app) {
    app
        .factory('store', storeFactory);

        function storeFactory () {
            return {
                "countries": ["USA", "UK", "Ukraine"]
            };
        }
}



// WEBPACK FOOTER //
// ./src/app/core/services/store.factory.js